/* 
import '../scripts/utils/theme-functions.js';
import '../scripts/utils/css-helpers.js';
*/

window.theme = {};

import '../scripts/components/';
import '../scripts/utils/lazy-images.js';

import '../scripts/legacy/vendor.min.js';
import '../scripts/legacy/theme.js';

import '../scripts/analytics/filter-events.js';
import { initAnalytics } from '../scripts/analytics/index.js';

import Swiper from 'swiper';

window.theme.Swiper = Swiper;

// Initialize all analytics tracking
initAnalytics();

// Dispatch event when theme bundle is loaded
document.dispatchEvent(new CustomEvent('theme:loaded'));
